<template>
    <div class="cp-form-wrap">
        <CurrentPartnerForm mode="edit" :entities="entities" :selected-item="selectedItem" @updated="onUpdated" @close="$emit('close')" />
    </div>
</template>

<script>
import CurrentPartnerForm from "./form.vue";
export default {
    name: "current-partners-edit",
    emits: ["updated", "close"],
    props: ["entities", "selectedItem"],
    components: { CurrentPartnerForm, },
    methods: {
        onUpdated(msg) {
            this.$emit('updated', msg);
        }
    },
}
</script>

<style scoped>
.cp-form-wrap {
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 100%;
}
</style>
